import React, { useMemo, useState } from "react";
import {
  type MRT_ColumnDef,
} from "material-react-table";
import { useTheme } from "@mui/material";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import { subrowActionCell } from "./table-action.subrow";
import RoleDropdown from "../../common/RoleDropwdown";
import { MoveUserModal } from "../../common/MoveUserModal";

export type TCohortUser = {
  roleID: string;
  roleName: string;
  groupID: string;
  groupType: string;
  groupName: string;
  name: string;
  userID: string;
};

const cohortUsersRoleCol = (handleOpenMoveUserModal): MRT_ColumnDef<TCohortUser>[] => [
  { header: "Name", accessorKey: "name", enableEditing: false,},
  { header: "Group Type", accessorKey: "groupType",enableEditing: false, },
  { header: "Group Name", accessorKey: "groupName",enableEditing: false, },
  { header: "Role",
    accessorKey: "roleName",
    Cell: (cell) => {
      return <RoleDropdown roleInfo={cell?.row?.original} />
    }
   },
  
  {
    header: "ACTION",
    size: 70,
    enableEditing: false,
    Cell: (props) =>
      subrowActionCell({
        ...props,
        handleOpenMoveUserModal,
      })
  },
];

const CohortUsersRoleTable = ({ row }) => {
  const theme = useTheme()
  const [moveUserModal, setMoveUserModal] = useState(false);
  const [currentRoleID, setCurrentRoleID] = useState("");
  const handleOpenMoveUserModal = (roleID) => {
    setCurrentRoleID(roleID)
    setMoveUserModal(true)
  };
  const handleCloseMoveUserModal = () => setMoveUserModal(false);
  const columns = useMemo<MRT_ColumnDef<TCohortUser>[]>(
    () => cohortUsersRoleCol(handleOpenMoveUserModal),
    []
  );

  const getSubRows = (item) =>
    item.roles.map((role) => ({
      ...role,
      name: item.name,
      userID:item?.userID
    }));
    
  return (
    <>
      <MoveUserModal
        open={moveUserModal}
        handleClose={handleCloseMoveUserModal}
        data={{ name: row.original?.name }}
        source="Cohort"
        currentRoleID={currentRoleID}
      />
      <AdminGlobalTable
        columns={columns}
        data={getSubRows(row.original)}
        config={{
          enableGlobalFilter: false,
          enableDensityToggle: false,
          enablePagination: false,
          
          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme?.custom?.hoverOptionColor },
            },
          }),
          renderTopToolbar: () => {
            return <></>;
          },
        }}
      />
    </>
  );
};

export default CohortUsersRoleTable;
